/* eslint-disable import/no-anonymous-default-export */
import { api } from "./apiServices";

export const loginAdmin = (user) => api().post("/admin/admin-login", user).then(handleResponse);
export const updateAdminPassword = (token, data) => api(token).post("/admin/admin-password-update", data).then(handleResponse);
export const checkAdminLogin = (token) => api(token).get("/admin/admin-check-login").then(handleResponse);
export const getCompanies = (token, user) => api(token).post("/admin/admin-companies-get", user).then(handleResponse);
export const getCompany = (token, id) => api(token).get("/admin/admin-companies-get/" + id).then(handleResponse);
export const getAdminKeys = (token, user) => api(token).post("/admin/admin-get-key-request", user).then(handleResponse);
export const updateAdminKeys = (token, user) => api(token).post("/admin/admin-update-key-request", user).then(handleResponse);
export const createAdminKeys = (token, user) => api(token).post("/admin/admin-create-key", user).then(handleResponse);
export const createOrUpdateAd = (token, data) => api(token).post('/admin/ads', data).then(handleResponse);
export const deleteAds = (token, id) => api(token).delete(`/admin/ads/${id}`).then(handleResponse);
export const getAllAds = (token, data) => api(token).get(`/admin/ads?page=${data.page}&limit=${data.limit}`).then(handleResponse);

export const createUser = (token, user) => api(token).post("/admin/admin-create-user", user).then(handleResponse);
export const updateUser = (token, id, user) => api(token).post("/admin/admin-update-user/" + id, user).then(handleResponse);
export const getGroups = (token, user) => api(token).post("/admin/admin-group-get", user).then(handleResponse);
export const createGroup = (token, user) => api(token).post("/admin/admin-create-group", user).then(handleResponse);
export const updateGroup = (token, id, user) => api(token).post("/admin/admin-update-group/" + id, user).then(handleResponse);
export const uploadLogo = (token, data) => api(token).post("/admin/logo-update/", data).then(handleResponse);
export const getTrackingData = (token, data) => api(token).post("/admin/admin-tracking-get/", data).then(handleResponse);
export const updateBillingDetails = (token, id, data) => api(token).post("/admin/admin-update-billing-details/" + id, data).then(handleResponse);
export const deleteUser = (token, id) => api(token).delete("/admin/admin-user-delete/" + id).then(handleResponse);
export const deleteGroup = (token, id) => api(token).delete("/admin/admin-group-delete/" + id).then(handleResponse);
export const getSuggestions = (token) => api(token).delete("/admin/get-work-suggestion").then(handleResponse);
export const getDashboardData = (token) => api(token).get("/admin/get-dashboard-data").then(handleResponse);
export const updatePlanSetting = (token, data) => api(token).post("/admin/update-plan-setting", data).then(handleResponse);
export const getPlan = (token) => api(token).get("/admin/get-plan").then(handleResponse);
export const getMasterDashboardData = (token) => api(token).get("/admin/get-dashboard-data").then(handleResponse);

export const getVersions = (token) => api(token).get("/admin/version").then(handleResponse);
export const createOrUpdateVersion = (token, data, config = {}) =>
  api(token)
    .post("/admin/version", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...config, // ✅ allows onUploadProgress
    })
    .then(handleResponse);
export const deleteVersion = (token, id) => api(token).delete("/admin/version/" + id).then(handleResponse);

const handleResponse = (response) => {
  let data = response.data;
  if (response.data.code == 6) {
    localStorage.removeItem("token");
    window.location.href = "/login";
  }
  return data;
};
